import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultShowtimePickerAssets, showtimePickerAssetsValidator } from '../../../subcomponents/showtime-picker/types/assets';
import { defaultShowtimePickerCdnOptions, showtimePickerCdnOptionsValidator } from '../../../subcomponents/showtime-picker/types/cdn-options';
import { showtimePickerEventsValidator } from '../../../subcomponents/showtime-picker/types/events';
import { dateShowtimePickerConfigWithFilmIdsValidator, dateShowtimePickerConfigWithoutFilmIdsValidator, defaultDateShowtimePickerConfigWithFilmIds, defaultDateShowtimePickerConfigWithoutFilmIds } from './config';
import { dateShowtimePickerDisplayTextValidator, defaultDateShowtimePickerDisplayText } from './display-text';
const dateShowtimePickerPropsBaseValidatorSchema = {
    siteIds: Validator.optional(Validator.array({ items: nonEmptyStringValidator })),
    displayText: dateShowtimePickerDisplayTextValidator,
    events: showtimePickerEventsValidator,
    assets: showtimePickerAssetsValidator,
    cdnOptions: showtimePickerCdnOptionsValidator
};
export const dateShowtimePickerPropsValidator = Validator.any([
    Validator.object(Object.assign(Object.assign({}, dateShowtimePickerPropsBaseValidatorSchema), { filmIds: Validator.array({ items: nonEmptyStringValidator }), config: dateShowtimePickerConfigWithFilmIdsValidator })),
    Validator.object(Object.assign(Object.assign({}, dateShowtimePickerPropsBaseValidatorSchema), { filmIds: Validator.isEqualTo(undefined), config: dateShowtimePickerConfigWithoutFilmIdsValidator }))
]);
export const defaultDateShowtimePickerPropsBase = {
    filmIds: undefined,
    siteIds: undefined,
    config: defaultDateShowtimePickerConfigWithoutFilmIds,
    displayText: defaultDateShowtimePickerDisplayText,
    assets: defaultShowtimePickerAssets,
    cdnOptions: defaultShowtimePickerCdnOptions,
    events: {}
};
export const defaultDateShowtimePickerPropsWithFilmIds = Object.assign(Object.assign({}, defaultDateShowtimePickerPropsBase), { filmIds: undefined, config: defaultDateShowtimePickerConfigWithFilmIds });
export const defaultDateShowtimePickerPropsWithoutFilmIds = defaultDateShowtimePickerPropsBase;
export const defaultDateShowtimePickerPropsProvider = props => {
    if ('filmIds' in props)
        return defaultDateShowtimePickerPropsWithFilmIds;
    return defaultDateShowtimePickerPropsWithoutFilmIds;
};
